import type { WorkAssignment } from "../types/work-assignment.types";
import { workAssignmentAssigneeId } from "./workAssignmentNormalize";

function isPresent(value: string | null | undefined): boolean {
  return value != null && String(value).trim() !== "";
}

/** Row is still open for work (not completed / not actually ended / not soft-deleted). */
export function isWorkAssignmentActive(a: WorkAssignment): boolean {
  if (a.isActive === false) return false;
  if (a.isActive === true) {
    if (isPresent(a.deleted_at)) return false;
    if (a.status === "COMPLETED") return false;
    if (isPresent(a.actualEndDate)) return false;
    return true;
  }
  if (isPresent(a.deleted_at)) return false;
  if (a.status === "COMPLETED") return false;
  if (isPresent(a.actualEndDate)) return false;
  if (a.status === "ASSIGNED") return true;
  if (a.status == null) {
    return !isPresent(a.actualEndDate);
  }
  return false;
}

export function isAssigneeOrSuperAdmin(
  assignment: WorkAssignment,
  currentUserId: number | null | undefined,
  isSuperAdmin: boolean,
): boolean {
  if (isSuperAdmin) return true;
  if (currentUserId == null) return false;
  return Number(workAssignmentAssigneeId(assignment)) === Number(currentUserId);
}

/** POST …/complete — assignee or super_admin; ASSIGNED. */
export function canCompleteWorkAssignment(
  a: WorkAssignment,
  currentUserId: number | null | undefined,
  isSuperAdmin: boolean,
): boolean {
  if (!isAssigneeOrSuperAdmin(a, currentUserId, isSuperAdmin)) return false;
  if (a.status !== "ASSIGNED") return false;
  return true;
}
